export function getWarningDotClasses(hasWarning?: boolean): string {
    return hasWarning ? "bg-amber-500" : "bg-transparent";
}
